import React from 'react';
import './Pagination.css';

interface PaginationProps {
    dispayNoOfItems?:boolean;
    currentPage: number;
    totalPages: number;
    totalItems?: number; // for total number of items
    onPageChange: (page: number) => void;
    className?: string; // For parent container styling
    pageRangeClassName?: string; // For parent container styling
    styleContainer?:any;
    arrowsClassName?: string; // For arrow buttons styling
    pageNumbersClassName?: string; // For page number buttons styling
    maxPagesToShow?: number; // Optional: Number of pages to show at a time
    itemsPerPage?: number
}

const PaginationUltra: React.FC<PaginationProps> = ({
    dispayNoOfItems = true,
    currentPage,
    totalPages,
    totalItems = 0,
    onPageChange,
    className = '',
    pageRangeClassName = '',
    styleContainer ={},
    arrowsClassName = '',
    pageNumbersClassName = '',
    maxPagesToShow = 5,
    itemsPerPage = 10
}) => {
    // Function to generate the page numbers to display
    const getPageNumbers = () => {
        const pages: number[] = [];
        let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

        // Adjust startPage if we're near the end
        if (endPage - startPage + 1 < maxPagesToShow) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        return pages;
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const handleFirst = () => {
        onPageChange(1);
    };

    const handleLast = () => {
        onPageChange(totalPages);
    };


    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    return (
        <>
            <div className={`react-pagination-ultra-container ${className}`} style={styleContainer}>
                {/* First Page Button */}
                <button
                    onClick={handleFirst}
                    disabled={currentPage === 1}
                    className={`react-pagination-ultra-btn ${arrowsClassName} ${currentPage === 1 ? 'disabled' : ''}`}
                >
                    ««
                </button>

                {/* Previous Page Button */}
                <button
                    onClick={handlePrevious}
                    disabled={currentPage === 1}
                    className={`react-pagination-ultra-btn ${arrowsClassName} ${currentPage === 1 ? 'disabled' : ''}`}
                >
                    &laquo;
                </button>

                {/* Page Numbers */}
                {getPageNumbers().map((page) => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`react-pagination-ultra-btn ${pageNumbersClassName} ${currentPage === page ? 'active' : ''}`}
                    >
                        {page}
                    </button>
                ))}

                {/* Next Page Button */}

                <button
                    onClick={handleNext}
                    disabled={currentPage === totalPages}
                    className={`react-pagination-ultra-btn ${arrowsClassName} ${currentPage === totalPages ? 'disabled' : ''}`}
                >
                    &raquo;
                </button>

                {/* Last Page Button */}

                <button
                    onClick={handleLast}
                    disabled={currentPage === totalPages}
                    className={`react-pagination-ultra-btn ${arrowsClassName} ${currentPage === totalPages ? 'disabled' : ''}`}
                >
                    &raquo;&raquo;
                </button>
            </div>

            {dispayNoOfItems && (<div className={`pagination-range ${pageRangeClassName}`}>
                Showing {startItem} to {endItem} of {totalItems} items
            </div>)}
        </>
    );
};

export default PaginationUltra;

// import React from 'react';
// import './Pagination.css';

// interface PaginationProps {
//   currentPage: number;
//   totalPages: number;
//   totalItems: number;
//   onPageChange: (page: number) => void;
//   className?: string;
//   arrowsClassName?: string;
//   pageNumbersClassName?: string;
//   maxPagesToShow?: number;
//   itemsPerPage?: number;
// }

// const PaginationPro: React.FC<PaginationProps> = ({
//   currentPage,
//   totalPages,
//   totalItems,
//   onPageChange,
//   className = '',
//   arrowsClassName = '',
//   pageNumbersClassName = '',
//   maxPagesToShow = 5,
//   itemsPerPage = 10,
// }) => {
//   const getPageNumbers = () => {
//     const pages: number[] = [];
//     let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
//     let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

//     if (endPage - startPage + 1 < maxPagesToShow) {
//       startPage = Math.max(1, endPage - maxPagesToShow + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(i);
//     }
//     return pages;
//   };

//   const handlePrevious = () => {
//     if (currentPage > 1) {
//       onPageChange(currentPage - 1);
//     }
//   };

//   const handleNext = () => {
//     if (currentPage < totalPages) {
//       onPageChange(currentPage + 1);
//     }
//   };

//   const handleFirst = () => {
//     onPageChange(1);
//   };

//   const handleLast = () => {
//     onPageChange(totalPages);
//   };

//   const startItem = (currentPage - 1) * itemsPerPage + 1;
//   const endItem = Math.min(currentPage * itemsPerPage, totalItems);

//   return (
//     <div className={`pagination-container ${className}`}>
//       <div className="pagination-range">
//         Showing {startItem} to {endItem} of {totalItems} items
//       </div>
//       <button
//         onClick={handleFirst}
//         disabled={currentPage === 1}
//         className={`pagination-btn pagination-arrow ${arrowsClassName} ${
//           currentPage === 1 ? 'disabled' : ''
//         }`}
//       >
//         ««
//       </button>
//       <button
//         onClick={handlePrevious}
//         disabled={currentPage === 1}
//         className={`pagination-btn pagination-arrow ${arrowsClassName} ${
//           currentPage === 1 ? 'disabled' : ''
//         }`}
//       >
//         «
//       </button>
//       {getPageNumbers().map((page) => (
//         <button
//           key={page}
//           onClick={() => onPageChange(page)}
//           className={`pagination-btn pagination-number ${pageNumbersClassName} ${
//             currentPage === page ? 'active' : ''
//           }`}
//         >
//           {page}
//         </button>
//       ))}
//       <button
//         onClick={handleNext}
//         disabled={currentPage === totalPages}
//         className={`pagination-btn pagination-arrow ${arrowsClassName} ${
//           currentPage === totalPages ? 'disabled' : ''
//         }`}
//       >
//         »
//       </button>
//       <button
//         onClick={handleLast}
//         disabled={currentPage === totalPages}
//         className={`pagination-btn pagination-arrow ${arrowsClassName} ${
//           currentPage === totalPages ? 'disabled' : ''
//         }`}
//       >
//         »»
//       </button>
//     </div>
//   );
// };

// export default PaginationPro;